import React from 'react';

export type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string;
};

const CreditsIcon: React.FC<IconProps> = ({ color = '#020511' }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="12"
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="7"
        y="14.39"
        width="11.3428"
        height="1.65992"
        rx="0.82996"
        fill={color}
      />
      <rect
        x="7"
        y="11.07"
        width="6.91633"
        height="1.65992"
        rx="0.82996"
        fill={color}
      />
      <rect
        x="9.49023"
        y="17.7094"
        width="3.59649"
        height="1.65992"
        rx="0.82996"
        fill={color}
      />
      <rect
        x="7"
        y="7.75"
        width="11.3428"
        height="1.65992"
        rx="0.82996"
        fill={color}
      />
      <rect
        x="15.5752"
        y="11.07"
        width="2.76653"
        height="1.65992"
        rx="0.82996"
        fill={color}
      />
    </svg>
  );
};

export default CreditsIcon;
